/**************************************************
 * Nombre:       Seccion_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_COMPARACION,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS, CASILLA_TEXTO,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOSSOPORTE, VISIBILIDADMOVIMIENTO} from "../../Constantes";
import Dialogo_Retiro from "../Dialogos/Dialogo_Retiro";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {where} from "firebase/firestore";
import Dialogo_Canjes from "../Dialogos/Dialogo_Canjes";
import Dialogo_Soporte from "../Dialogos/Dialogo_Soporte";


const Seccion_Soporte = () => {
    const [wheres, setWheres] = useState(
        []);
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'soportes', wheres: wheres});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Soporte,
        titulo: 'Detalles del soporte',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista ticket de soporte'}
                        descripcion={`${numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Soporte

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y tipo',
        direccion: 'left',
        propiedades: ['consecutivo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: "correo",
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Asunto',
        direccion: 'left',
        propiedad: 'asunto',
        tipo: CASILLA_TEXTO

    },

    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSSOPORTE
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]